import React, { useState, useEffect } from 'react';
import '../Components/CSS/Global.css';

const features = [
    { id: 1, name: "Content Library Management", price: 150 },
    { id: 2, name: "User Subscription Plans", price: 100 },
    { id: 3, name: "Multi-Device Streaming", price: 120 },
    { id: 4, name: "High-Definition (HD) Streaming", price: 200 },
    { id: 5, name: "Watchlist Management", price: 50 },
    { id: 6, name: "Personalized Recommendations", price: 130 },
    { id: 7, name: "Parental Controls", price: 60 },
    { id: 8, name: "Offline Viewing", price: 90 },
    { id: 9, name: "Content Ratings & Reviews", price: 40 },
    { id: 10, name: "User Profiles", price: 70 },
];

const OTTPlatformPricing = () => {
    const [selectedFeatures, setSelectedFeatures] = useState([]);

    useEffect(() => {
        const savedFeatures = JSON.parse(localStorage.getItem("selectedFeatures")) || [];
        setSelectedFeatures(savedFeatures);
    }, []);

    useEffect(() => {
        localStorage.setItem("selectedFeatures", JSON.stringify(selectedFeatures));
    }, [selectedFeatures]);

    const toggleFeature = (feature) => {
        setSelectedFeatures(prevSelected => {
            if (prevSelected.includes(feature.id)) {
                return prevSelected.filter(id => id !== feature.id);
            } else {
                return [...prevSelected, feature.id];
            }
        });
    };

    const totalAmount = selectedFeatures.reduce((total, featureId) => {
        const feature = features.find(f => f.id === featureId);
        return total + (feature ? feature.price : 0);
    }, 0);

    return (
        <>
            <div className="pricing">
            <h2>Select Services</h2>
                {features.map(feature => (
                    <div key={feature.id} className="pricing-list">
                        <div className="price-title">
                            {feature.name}
                        </div>
                        <div className="price-toggle-container">
                            <div className="price-amount">
                                ₹{feature.price}
                            </div>
                            <div className="toggle-container">
                                <label className="switch">
                                    <input 
                                        type="checkbox" 
                                        checked={selectedFeatures.includes(feature.id)} 
                                        onChange={() => toggleFeature(feature)} 
                                    />
                                    <span className="slider"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pricing-total">
                <h2>Total: ₹{totalAmount}</h2>
                <button>Proceed</button>
            </div>
        </>
    );
};

export default OTTPlatformPricing;
